import React, { useState } from "react";

const DESTINATIONS = [
  {
    code: "VIG",
    label: "vigliettisport.com",
    description: "Invia a Viglietti testi e immagini del prodotto.",
  },
  {
    code: "BOT",
    label: "botteroski.com",
    description: "Invia a Bottero testi e immagini del prodotto.",
  },
];

function Impostazioni({ destinations = [], onDestinationsChange, disabled }) {
  const [activeSection, setActiveSection] = useState("destinazioni");

  const toggleDestination = (code) => {
    if (disabled || typeof onDestinationsChange !== "function") return;
    const current = Array.isArray(destinations) ? destinations : [];
    onDestinationsChange(
      current.includes(code)
        ? current.filter((item) => item !== code)
        : [...current, code],
    );
  };

  return (
    <section className="modificaProdottiPagina modificaProdottiImpostazioni">
      <nav
        className="modificaProdottiImpostazioniNav"
        aria-label="Voci impostazioni prodotto"
      >
        <button
          type="button"
          className={
            "modificaProdottiDatiAltroveNavItem" +
            (activeSection === "destinazioni"
              ? " modificaProdottiDatiAltroveNavItem--active"
              : "")
          }
          onClick={() => setActiveSection("destinazioni")}
        >
          Destinazioni
        </button>
      </nav>

      <div className="modificaProdottiImpostazioniContent pa3">
        {activeSection === "destinazioni" && (
          <div>
            <h3 className="mt0 mb2">Destinazioni di pubblicazione</h3>
            <p className="mt0 mb3 lh-copy gray">
              Scegli i siti ai quali Domino invierà testi e immagini quando il
              prodotto viene salvato o le immagini vengono consegnate.
            </p>
            <div className="modificaProdottiDestinazioniList">
              {DESTINATIONS.map((destination) => {
                const checked = destinations.includes(destination.code);
                return (
                  <label
                    key={destination.code}
                    className={
                      "modificaProdottiDestinazione ba bordoColAlt br2 pa3 pointer" +
                      (checked
                        ? " modificaProdottiDestinazione--selected"
                        : "")
                    }
                  >
                    <input
                      type="checkbox"
                      className="mr3"
                      checked={checked}
                      disabled={disabled}
                      onChange={() => toggleDestination(destination.code)}
                    />
                    <span>
                      <strong className="db">{destination.label}</strong>
                      <span className="db f7 gray mt1">
                        {destination.description}
                      </span>
                    </span>
                  </label>
                );
              })}
            </div>
            {!destinations.length && (
              <p className="dark-red f7 mt3 mb0">
                Nessun sito selezionato: testi e immagini non verranno inviati
                a Prestashop. La copia immagini destinata a Moda resta separata.
              </p>
            )}
            {disabled && (
              <p className="gray f7 mt3 mb0">
                Serve il permesso update:database per modificare le destinazioni.
              </p>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default Impostazioni;
